import { gql } from '@apollo/client'

export const GET_CURRENT_FANTASY_LEAGUE_MEMBER_ACTIVE_MARKET_ENTRIES = gql`
  query GetCurrentFantasyLeagueMemberActiveMarketEntries($fantasyLeagueId: ID!) {
    currentFantasyLeagueMemberActiveMarketEntries(fantasyLeagueId: $fantasyLeagueId) {
      id
      player {
        id
      }
    }
  }
`
